<template>
  <div class="tile">
    <template v-if="$store.getters.getMgms">
      <h6 class="title primary">{{ $t("Inviti da confermare") }}</h6>
      <div class="circle primary-bg">{{ $store.getters.getMgms }}</div>
      <p class="desc">
        {{ $t("Inviti in attesa") }}
      </p>
    </template>
    <template v-else>
      <h6 class="title primary">{{ $t("Nessun invito da confermare") }}</h6>
    </template>
  </div>
</template>

<script>
export default {
  name: "InvitationsTile",
  mounted() {}
};
</script>

<style lang="scss" scoped>
.circle {
  border-radius: 50%;
  color: #fff;
}
</style>
